<template>
  <div class="attendance">
    <breadcrumb :titleList="[{name:'凤凰管理系统', src:'/home'},{name:'考勤管理'}]"></breadcrumb>
    <div class="attendance-wrap">
      <div class="attendance-contain">
        <public-top-nav>
          <div>
            <el-date-picker @change="monthChange"
                            v-model="month"
                            type="month"
                            placeholder="选择年月"></el-date-picker>
            <el-select class="user-form_input"
                       v-model="params.departmentId"
                       @change="searchChange"
                       placeholder="所有部门">
              <el-option v-for="item in departmentList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id"></el-option>
            </el-select>
            <el-input clearable
             @keyup.enter.native="searchChange()"
                      v-model="params.userName"
                      placeholder="请输入用户名">
              <i slot="prefix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
        </public-top-nav>
        <div class="attendance-table-wrap">
          <div class="attendance-table_title">
            <div class="attendance-table_title_right">
              <a @click=" $refs['file'].click()"
                 class="attendance-table_download">
                <input class="attendance-table-file_input"
                       type="file"
                       style="display:none"
                       @change="importExcel"
                       ref="file">
                <font-awesome-icon style="color:#F0722B;margin-right:5px"
                                   :icon="['fas', 'level-down-alt']" />导入Excel
              </a>
            </div>
          </div>
          <div class="attendance-table">
            <table border="1"
                   cellspacing="0"
                   style="table-layout:fixed;border-color:#E6E3E3">
              <tr>
                <th width="88"
                    rowspan="3">姓名</th>
                <th width="100"
                    rowspan="3">部门</th>
                <th style="width:48px;padding:0 8px;"
                    rowspan="3">正常统计</th>
                <th style="width:48px;padding:0 8px;"
                    rowspan="3">迟到统计</th>
                <th style="width:48px;padding:0 8px;"
                    rowspan="3">早退统计</th>
                <th style="width:48px;padding:0 8px;"
                    rowspan="3">未打卡数</th>
                <th style="height:27px"
                    :colspan="daysInMonth">
                  日期
                </th>
              </tr>
              <tr style="height:27px">
                <th style="width:26px;"
                    v-for="m of daysInMonth"
                    :key="m">{{m}}</th>
              </tr>
              <tr style="height:27px">
                <th style="width:26px;"
                    v-for="m of daysInMonth"
                    :key="m">{{(m+monthOfFirst-1)%7|dayFilter}}</th>
              </tr>
              <tr v-for="item in attendanceList"
                  :key="item.id">
                <td>{{item.userName}}</td>
                <td>{{item.departmentName}}</td>
                <td>{{item.zhengchang}}</td>
                <td>{{item.chidao}}</td>
                <td>{{item.zaotui}}</td>
                <td>{{item.weidaka}}</td>
                <td v-for="(d,index) in item.attendanceText"
                    :key="index"
                    style="text-align:center;font-size:30px;padding:0px;">
                  <div v-if="d==='0'" style="color:#E6E3E3">○</div>
                  <div style="width:100%"
                       :style="{color:colorList[Number(d)-1]}"
                       v-else>●</div>
                </td>
              </tr>
              <tr style="height:50px">
                <td style="font-size:14px;"
                    :colspan="daysInMonth+6">
                  <div style="display:flex;align-items:center;justify-content:center">
                     <span style="color:#39B54A;font-size:30px;margin-right:3px;margin-left:5px">●</span>正常
                    <span style="color:#F0722B;font-size:30px;margin-right:3px;margin-left:5px">●</span>迟到
                    <span style="color:#9013FE;font-size:30px;margin-right:3px;margin-left:5px">●</span>早退
                    <span style="color:#409EFF;font-size:30px;margin-right:3px;margin-left:5px">●</span>出差
                    <span style="color:#474747;font-size:30px;margin-right:3px;margin-left:5px">●</span>请假
                    <span style="color:#99D7D1;font-size:30px;margin-right:3px;margin-left:5px">●</span>休假
                     <span style="color:#E6E3E3;font-size:30px;margin-right:3px;margin-left:5px">○</span>未打卡</div>
                </td>
              </tr>
            </table>
          </div>
          <el-pagination @current-change="changePage"
                         :current-page="params.current"
                         class="attendance-pagination"
                         background
                         layout="prev, pager, next"
                         :total="total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/servies/axios'
import api from '@/servies/api'
import breadcrumb from '@/components/breadcrumb'
import publicTopNav from '@/components/publicTopNav'
import { create } from 'domain'
import moment from 'moment'
export default {
  components: {
    breadcrumb,
    publicTopNav
  },
  data() {
    return {
      colorList: [
        '#39B54A',
        '#F0722B',
        '#9013FE',
        '#409EFF',
        '#474747',
        '#99D7D1'
      ],
      departmentList: [],
      attendanceList: [],
      month: '',
      daysInMonth: 0,
      monthOfFirst: 1,
      total: 0,
      params: {
        current: 1,
        departmentId: '',
        month: 3,
        pageSize: 10,
        userName: '',
        year: 2019
      }
    }
  },
  filters: {
    dayFilter(value) {
      switch (value) {
        case 0:
          return '日'
        case 1:
          return '一'
        case 2:
          return '二'
        case 3:
          return '三'
        case 4:
          return '四'
        case 5:
          return '五'
        case 6:
          return '六'
      }
    }
  },
  created() {
    this.month = new Date()
    this.initList()
    this.monthChange()
  },
  methods: {
    initList() {
      //获取部门列表
      axios
        .get(api.departList)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取部门列表成功', res.data.result)
            this.departmentList = res.data.result
          } else {
            console.log('获取部门列表失败', res.data.msg)
          }
        })
        .catch(error => {
          console.log('获取部门列表失败', error)
        })
    },
    searchChange() {
      this.params.current = 1
      this.getList()
    },
    getList() {
      axios
        .post(api.getAttendanceList, this.params)
        .then(res => {
          if (res.data.code === 0) {
            console.log('获取考勤列表成功', res.data)
            this.attendanceList = res.data.result.records
            this.total = res.data.result.total
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error('网络错误，请稍后重试')
        })
    },
    monthChange() {
      this.daysInMonth = moment(this.month).daysInMonth()
      this.monthOfFirst = moment([
        this.month.getFullYear(),
        this.month.getMonth(),
        1
      ]).day()
      this.params.month = this.month.getMonth() + 1
      this.params.year = this.month.getFullYear()
      this.getList()
    },
    changePage(v) {
      this.params.current = v
      this.getList()
    },
    //导入数据
    importExcel(e) {
      let file = e.target.files[0]
      if (file.length) {
        return
      }
      let param = new FormData()
      let config = {
        headers: { 'Content-Type': 'multipart/form-data' }
      }
      param.append('file', file)
      axios
        .post(api.importAttendance, param, config)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              message: '上传文件成功',
              type: 'success'
            })
            this.getList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch(error => {
          this.$message.error('网络错误，稍后重试')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.attendance {
  .attendance-wrap {
    padding: 77px 30px 30px 30px;
    .attendance-contain {
      background: #fff;
      border-radius: 4px;
      border: 1px solid #e6e3e3;
      .el-input {
        width: 150px;
      }
      .el-select {
        width: 120px;
        margin-right: 10px;
      }
      .el-date-editor {
        width: 120px;
        margin-right: 10px;
      }

      .attendance-table-wrap {
        padding: 30px;
        .attendance-table_title {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 27px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .attendance-table_title_right {
            display: flex;
            .attendance-table_bar {
              background: #fff;
              height: 40px;
              width: 50px;
              cursor: pointer;
              line-height: 40px;
              text-align: center;
              border-radius: 4px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
              margin-left: 10px;
            }
            .attendance-table_download {
              margin-left: 10px;
              cursor: pointer;
              text-decoration: none;
              width: 108px;
              height: 40px;
              border-radius: 4px;
              border: 1px solid rgba(220, 223, 230, 1);
              color: #9b9b9b;
              font-size: 14px;
              font-weight: 500;
              line-height: 40px;
              text-align: center;
            }
          }
        }
        .attendance-table {
          min-height: 470px;
          table {
            border-color: #e6e3e3;
          }
          tr {
            cursor: pointer;
            padding: 0px;
            border-color:#E6E3E3;
            background: #fff;
            th {
              border-color:#E6E3E3;
              box-sizing: border-box;
              background: #e6e3e3;
              color: #9b9b9b;
              font-size: 14px;
              padding: 0px;
              font-weight: 600;
            }
            td {
              border-color: #E6E3E3;
              padding: 0px 19px;
              div {
                display: inline-block;
              }
            }
          }
        }
        .attendance-pagination {
          margin-top: 36px;
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
}
</style>
